import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const OrganizationHasNoCompleteUploadsError = BaseErrorSchema.extend({
  errorType: z.literal('OrganizationHasNoCompleteUploadsError'),
  id: z.string(),
});

export type OrganizationHasNoCompleteUploadsError = z.infer<
  typeof OrganizationHasNoCompleteUploadsError
>;
